import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  fullScreen?: boolean;
}

/**
 * Loading Spinner Component
 * Displays a loading indicator with optional text
 * Can be used inline or as a full-screen overlay
 */
export const LoadingSpinner = ({ 
  size = 'large', 
  tip = 'Loading...', 
  fullScreen = false 
}: LoadingSpinnerProps) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size === 'large' ? 48 : size === 'default' ? 32 : 24 }} spin />;

  if (fullScreen) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: '#ffffff',
        }}
      >
        <Spin indicator={antIcon} size={size} />
        {tip && (
          <div style={{ marginTop: 16, color: '#000000', fontSize: 16 }}>
            {tip}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 0',
      }}
    >
      <Spin indicator={antIcon} size={size} tip={tip} />
    </div>
  );
};
